import { useMemo } from "react";
import WelcomeBonusCardContainer from "containers/organisms/WelcomeBonusCardContainer";
import useTranslate from "hooks/useTranslate";
import { BONUS_STATUS, BonusListType } from "types/Bonus";
import BonusCard from "../BonusCard";

import "./styles.sass";

type BonusListProps = {
  list: BonusListType[];
  hasFirstDeposit: boolean | null;
  setCanceledBonus: (bonus: BonusListType) => void;
  currency: string;
};

const BonusList = (props: BonusListProps) => {
  const { list, hasFirstDeposit, setCanceledBonus, currency } = props;
  const t = useTranslate();

  const activeList = useMemo(
    () =>
      list.filter(
        (bonus) => bonus.status.toLowerCase() === BONUS_STATUS.ACTIVE,
      ),
    [list],
  );

  const queueList = useMemo(
    () =>
      list.filter((bonus) => bonus.status.toLowerCase() === BONUS_STATUS.QUEUE),
    [list],
  );

  const deactiveList = useMemo(
    () =>
      list.filter(
        (bonus) =>
          bonus.status.toLowerCase() === BONUS_STATUS.DEACTIVE ||
          bonus.status.toLowerCase() === BONUS_STATUS.AVAILABLE ||
          bonus.status.toLowerCase() === BONUS_STATUS.AVAILABLE_QUEUE,
      ),
    [list],
  );

  return (
    <div className="BonusList">
      {activeList.length ? (
        <div className="BonusList__wrapper">
          <div className="BonusList__title">{t("bonus.title.active")}</div>
          <div className="BonusList__list">
            {activeList.map((bonus) => (
              <BonusCard
                bonus={bonus}
                currency={currency}
                setCanceledBonus={setCanceledBonus}
                key={
                  "id" in bonus
                    ? bonus.id
                    : bonus.type + bonus.expireAt + bonus.amount
                }
              />
            ))}
          </div>
        </div>
      ) : null}
      {queueList.length ? (
        <div className="BonusList__wrapper">
          <div className="BonusList__title">{t("bonus.title.queue")}</div>
          <div className="BonusList__list">
            {queueList.map((bonus) => (
              <BonusCard
                bonus={bonus}
                currency={currency}
                setCanceledBonus={setCanceledBonus}
                key={
                  "id" in bonus
                    ? bonus.id
                    : bonus.type + bonus.expireAt + bonus.amount
                }
              />
            ))}
          </div>
        </div>
      ) : null}
      {!deactiveList.length && hasFirstDeposit ? null : (
        <div className="BonusList__wrapper">
          <div className="BonusList__title">{t("bonus.title.available")}</div>
          <div className="BonusList__list">
            {!hasFirstDeposit ? <WelcomeBonusCardContainer /> : null}
            {!!deactiveList.length &&
              deactiveList.map((bonus) => (
                <BonusCard
                  bonus={bonus}
                  currency={currency}
                  key={
                    "id" in bonus
                      ? bonus.id
                      : bonus.type + bonus.expireAt + bonus.amount
                  }
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BonusList;
